<template>
  <div class="levelTwo-page">

    <!-- Skeleton -->
    <template v-if="isLoading">
      <div class="levelTwo-page__skeleton-hero skeleton"></div>
      <div class="levelTwo-page__skeleton-breadcrumb">
        <div class="skeleton skeleton--line" style="width: 240px;"></div>
      </div>
      <div class="levelTwo-page__skeleton-main">
        <div class="levelTwo-page__skeleton-text">
          <div class="skeleton skeleton--line" style="width: 100px; height: 14px; margin-bottom: 24px;"></div>
          <div class="skeleton skeleton--line"></div>
          <div class="skeleton skeleton--line"></div>
          <div class="skeleton skeleton--line" style="width: 85%;"></div>
          <div class="skeleton skeleton--line"></div>
          <div class="skeleton skeleton--line" style="width: 92%;"></div>
          <div class="skeleton skeleton--line" style="width: 60%;"></div>
        </div>
        <div class="levelTwo-page__skeleton-sidebar">
          <div class="skeleton" style="height: 180px; border-radius: 8px;"></div>
          <div class="skeleton" style="height: 300px; border-radius: 8px; margin-top: 16px;"></div>
        </div>
      </div>
      <div class="levelTwo-page__skeleton-cards">
        <div v-for="n in 4" :key="n" class="skeleton levelTwo-page__skeleton-card"></div>
      </div>
    </template>

    <!-- Content -->
    <template v-else>
      <section class="levelTwo-page__intro">
        <div class="levelTwo-page__hero-content">
          <h1>{{ ferramenta.nome }}. {{ ferramenta.descricao }}</h1>
        </div>
      </section>

      <section class="levelTwo-page__breadcrum">
        <div class="levelTwo-page__breadcrum-content">
          <h3 class="levelTwo-page__breadcrum-text">
            {{ $t("tools-page__hero-contente") }} >
          </h3>
          <h3 class="levelTwo-page__breadcrum-text2">
            {{ ferramenta.nome }}. {{ ferramenta.descricao }}
          </h3>
        </div>
      </section>

      <section class="levelTwo-page__main">
        <div class="levelTwo-page__main-content">
          <div class="levelTwo-page__main-text">
            <div v-if="tempoLeituraMin" class="levelTwo-page__reading-time">
              <span>{{ tempoLeituraMin }} min {{ $t('reading_time') }}</span>
            </div>
            <div v-html="versaoConteudo"></div>
          </div>
          <div class="levelTwo-page__sidebar">
            <ContentTOC :content="versaoConteudo" container-class="levelTwo-page__main-text" />
            <ToolIndex />
          </div>
        </div>
      </section>

      <section class="levelTwo-page__subgroups">
        <div class="levelTwo-page__subgroups-content">
          <h2>{{ $t("levelOne-page__subgroups-title") }}</h2>
          <div class="levelTwo-page__subgroups-menu">
            <div v-if="subgroupsNivel2.length > 0" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 20px;">
              <div
                v-for="subgroup in paginatedSubgroups"
                :key="subgroup.id"
                class="levelTwo-page__subgroups-menu-item"
                @click="navigateToTool(subgroup.id)"
                role="button"
                tabindex="0"
                @keydown.enter="navigateToTool(subgroup.id)"
                @keydown.space="navigateToTool(subgroup.id)"
              >
                <p>{{ subgroup.nome }}. {{ subgroup.descricao }}</p>
              </div>
            </div>
            <div v-else>
              <p>Nenhum subgrupo encontrado para esta ferramenta.</p>
            </div>
          </div>
          <AppPagination
            v-model="currentPage"
            :total-items="subgroupsNivel2.length"
            :items-per-page="ITEMS_PER_PAGE"
          />
        </div>
      </section>
    </template>

  </div>
</template>

<script>
import ToolIndex from "../ToolIndex/index.vue";
import ContentTOC from "../ContentTOC/index.vue";
import AppPagination from "../Pagination/index.vue";
import { useLevelTwo } from "./script.js";

export default {
  name: "LevelTwo",
  components: {
    ToolIndex,
    ContentTOC,
    AppPagination,
  },
  setup() {
    const {
      ferramenta,
      versaoConteudo,
      versaoExcerpt,
      tempoLeituraMin,
      isLoading,
      subgroupsNivel2,
      paginatedSubgroups,
      currentPage,
      ITEMS_PER_PAGE,
      navigateToTool,
    } = useLevelTwo();

    return {
      ferramenta,
      versaoConteudo,
      versaoExcerpt,
      tempoLeituraMin,
      isLoading,
      subgroupsNivel2,
      paginatedSubgroups,
      currentPage,
      ITEMS_PER_PAGE,
      navigateToTool,
    };
  },
};
</script>

<style scoped src="./style.css"></style>
